const CarbonCreditPrivateOffering = {
  "_format": "hh-sol-artifact-1",
  "contractName": "CarbonCreditPrivateOffering",
  "sourceName": "contracts/core/CarbonCreditPrivateOffering.sol",
  "abi": [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "inputs": [],
      "name": "ALREADY_REGISTERED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_WITHDRAWN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_ADMIN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_OWNER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_PARTNER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "BAD_INPUT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E28",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E71",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E75",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E76",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "EXCEEDS_ALLOCATION",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "EXCEEDS_REMAINING",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "HIGH_COMMISSION",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INSUFFICIENT_BALANCE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "KYC_REQUIRED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_APPROVED_BIDDER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_CANCELLED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_ENDED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_IMPLEMENTED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_INACTIVE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_LIVE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_PAUSED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_REGISTERED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_COMMISSION",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_DEPOSIT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_FUNDS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_ADDR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_ADDRESS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_AMOUNT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_CONFIG",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_FUNDING",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "bidder",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "allocation",
          "type": "uint256"
        }
      ],
      "name": "BidderApproved",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "bidder",
          "type": "address"
        }
      ],
      "name": "BidderRegistered",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "isPartner",
          "type": "bool"
        }
      ],
      "name": "CommissionWithdrawn",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "FundsWithdrawn",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [],
      "name": "OfferingCancelled",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "fundsCollected",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "remaining",
          "type": "uint256"
        }
      ],
      "name": "OfferingEnded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [],
      "name": "OfferingPaused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "listingEnd",
          "type": "uint64"
        }
      ],
      "name": "OfferingStarted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [],
      "name": "OfferingUnpaused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "buyer",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "usdcAmount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokensReturned",
          "type": "uint256"
        }
      ],
      "name": "RefundClaimed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "seller",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "SellerDeposited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "buyer",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "cost",
          "type": "uint256"
        }
      ],
      "name": "TokensPurchased",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "seller",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "UnsoldTokensWithdrawn",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "admin",
          "type": "address"
        }
      ],
      "name": "addAdmin",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        }
      ],
      "name": "addOwner",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "admins",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "actionId",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        }
      ],
      "name": "approvals",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "bidder",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "allocation",
          "type": "uint256"
        }
      ],
      "name": "approveBidder",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "newAuditors",
          "type": "address[]"
        },
        {
          "internalType": "uint256",
          "name": "newThreshold",
          "type": "uint256"
        }
      ],
      "name": "assignNewAuditor",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "bid",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "bidderList",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "bidders",
      "outputs": [
        {
          "internalType": "bool",
          "name": "registered",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        },
        {
          "internalType": "uint256",
          "name": "allocation",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "totalPaid",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "totalTokens",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "biotoken",
      "outputs": [
        {
          "internalType": "contract IERC1155",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "cancel",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "cancelled",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "claimRefund",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "actionId",
          "type": "uint256"
        },
        {
          "internalType": "uint8",
          "name": "group",
          "type": "uint8"
        }
      ],
      "name": "clearApprovals",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "end",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "factory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "fundsCollected",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "fundsWithdrawn",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getBidderCount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "bidder",
          "type": "address"
        }
      ],
      "name": "getBidderInfo",
      "outputs": [
        {
          "internalType": "bool",
          "name": "registered_",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "approved_",
          "type": "bool"
        },
        {
          "internalType": "uint256",
          "name": "allocation",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "totalPaid",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "totalTokens",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getFundsPaid",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getFundsUnlocked",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "group",
          "type": "uint8"
        }
      ],
      "name": "getGroup",
      "outputs": [
        {
          "internalType": "address[]",
          "name": "members",
          "type": "address[]"
        },
        {
          "internalType": "uint256",
          "name": "threshold",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getOfferingStatus",
      "outputs": [
        {
          "internalType": "enum CarbonCreditPrivateOffering.OfferingState",
          "name": "state",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "remaining_",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "fundsCollected_",
          "type": "uint256"
        },
        {
          "internalType": "uint64",
          "name": "listingEnd_",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "bidder",
          "type": "address"
        }
      ],
      "name": "getRemainingAllocation",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "stableCoin_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "biotoken_",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId_",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "seller_",
          "type": "address"
        },
        {
          "internalType": "address payable",
          "name": "projectFundingAddress_",
          "type": "address"
        },
        {
          "internalType": "address payable",
          "name": "partnerAddress_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "operatorAddress_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "factory_",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "listingPrice_",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "listingPeriodDays_",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "totalSupply_",
          "type": "uint256"
        },
        {
          "internalType": "uint8",
          "name": "targetYear_",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "usdCommission_",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "partnerUsdCommission_",
          "type": "uint8"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "enum CarbonCreditPrivateOffering.MultisigGroup",
          "name": "group",
          "type": "uint8"
        }
      ],
      "name": "isSigner",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycEnabled",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycWhitelist",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "listingEnd",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "listingPeriod",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "listingPrice",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "offeringState",
      "outputs": [
        {
          "internalType": "enum CarbonCreditPrivateOffering.OfferingState",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "onERC1155BatchReceived",
      "outputs": [
        {
          "internalType": "bytes4",
          "name": "",
          "type": "bytes4"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "onERC1155Received",
      "outputs": [
        {
          "internalType": "bytes4",
          "name": "",
          "type": "bytes4"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "operatorAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "owners",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "partnerAddress",
      "outputs": [
        {
          "internalType": "address payable",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "partnerUsdCommission",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "partnerUsdCommissionAmount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "partnerUsdCommissionWithdrawn",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "pause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paused",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paymentSlice",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "projectFundingAddress",
      "outputs": [
        {
          "internalType": "address payable",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "publicOffering",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "register",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "remaining",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "admin",
          "type": "address"
        }
      ],
      "name": "removeAdmin",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "seller",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "sellerDeposited",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_kycWhitelist",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "_enabled",
          "type": "bool"
        }
      ],
      "name": "setKYCWhitelist",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stableCoin",
      "outputs": [
        {
          "internalType": "contract IERC20",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "start",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "targetYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "tokenId",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "unlockTime",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "unpause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "usdCommission",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "usdCommissionAmount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "usdCommissionWithdrawn",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "withdrawCommission",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "withdrawFunds",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "withdrawPartnerCommission",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "withdrawUnsoldTokens",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "bytecode": "0x60808060405234620000c6576000549060ff8260081c1662000074575060ff8082160362000038575b6040516135569081620000cc8239f35b60ff90811916176000557f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb3847402498602060405160ff8152a13862000028565b62461bcd60e51b815260206004820152602760248201527f496e697469616c697a61626c653a20636f6e747261637420697320696e697469604482015266616c697a696e6760c81b6064820152608490fd5b600080fdfe608080604052600436101561001357600080fd5b600090813560e01c90816301ffc9a71461247957508063022914a71461243a57806308551a5314612411578063112356d714612378578063127effb21461234f578063133e64301461232e5780631785f53c146121e057806317d70f7c146121c257806318160ddd146121a45780631aa3a008146120b85780632135b2b91461208d57806324600fc314611fd2578063251c1aa314611f5a57806325da499a14611fa957806328bea87214611f855780632f6965b614611f5a5780633145862914611f31578063347c230614611ef45780633d70a11d14611ea55780633d81b39714611e8a5780633e25e83714611dd75780633f4ba83a14611d1e578063429b62e514611cdf578063454a2ab3146119b55780634978df891461199757806355234ec01461197957806355fd7fe51461195b578063576168fc146119325780635a918d1e1461190c5780635c975abb146118da5780635d5d2e7f146112075780636638a0fa146111365780636d3ca6b9146110335780637048027514610fdb5780637065cb4814610f71578063724403f114610ec857806373171f6414610e9e578063809f67aa14610e785780638456cb5914610e0157806384f9810a14610ddd57806387573f0d14610dc25780638a3fd9d514610d995780638f8b252e14610d7b57806395c0d84b14610d56578063992642e514610d2d5780639a82a09a14610cfb578063a12406db14610cdd578063a6fcb05314610cb7578063ab2850da14610c6b578063abb26aca14610a28578063ac307fcf14610a05578063b0d4c8aa146109dc578063b2363128146109b0578063b5545a3c14610870578063bc197c81146107e3578063be9a6555146106f8578063c452a7d61461062d578063c45a015514610604578063c78f19f9146105e6578063c87da02d146105c8578063c8bdbfb6146105a0578063d3584e8414610552578063d4f2cd1614610534578063ea8a1af014610471578063efbe1c1c146103ef578063f23a6e61146103855763fcc8f7931461030257600080fd5b34610382576020366003190112610382576040906001600160a01b036103266124ce565b168152604660205220805461037e6001830154926003600282015491015490604051948460ff80889760081c169116869192608093969594919660a08401971515845215156020840152604083015260608201520152565b0390f35b80fd5b50346103825760a03660031901126103825761039f6124ce565b506103a86124e4565b90608435906001600160401b0382116103825760206103dc846103ce3660048701612614565b506064359060443590612a2a565b6040516001600160e01b03199091168152f35b5034610382578060031936011261038257338152604960205260ff6040822054161561045f5760ff60455460181c16600581101561044b5760010361043957610436612c2b565b80f35b60405163168e97c560e01b8152600490fd5b634e487b7160e01b82526021600452602482fd5b60405163133461b160e11b8152600490fd5b5034610382578060031936011261038257338152604960205260ff6040822054161561045f5760455460ff8160181c1660058110156105205760048114908115610515575b506104395763030000009063ff00000019161760455560008051602061350a833981519152604080517faeba9e070ff5f67eefc33170c3fa8d3ea2f5b237c1f570eb02665011f16b8f988480a1604154603e549082526020820152a180f35b6003915014386104b6565b634e487b7160e01b83526021600452602483fd5b50346103825780600319360112610382576020604154604051908152f35b50346103825760203660031901126103825760043560475481101561059c5760476000526000805160206134ea83398151915201546040516001600160a01b039091168152602090f35b5080fd5b50346103825780600319360112610382576105b9612b9b565b6105c16128ad565b6001805580f35b50346103825780600319360112610382576020604754604051908152f35b50346103825780600319360112610382576020603c54604051908152f35b5034610382578060031936011261038257603b546040516001600160a01b039091168152602090f35b5034610382576040366003190112610382576004356024359160ff83168093036106f357818152604b60205260408120600101546001600160a01b0316156106e15760048310156106cd57506106838233612728565b80156106be575b156106ac5761069b6106a192612698565b90613241565b602060405160018152f35b60405163afe2d74b60e01b8152600490fd5b506106c8336126b1565b61068a565b634e487b7160e01b81526021600452602490fd5b60405163ea8ecccb60e01b8152600490fd5b600080fd5b5034610382578060031936011261038257338152604960205260ff6040822054161561045f5760455460ff8160181c166005811015610520576107d157603754603f54116107bf57603d547f2286f51d91a6656bf7b22142765813b57fd82aad7e7ee48f60c851a17be7d851916020916001600160401b0390630100000090600160401b600160801b0361078e848316426127b1565b60401b1690600160401b600160801b031916179283603d5563ff0000001916176045556040519160401c168152a180f35b604051630362063760e21b8152600490fd5b604051633679643760e11b8152600490fd5b50346103825760a0366003190112610382576107fd6124ce565b506108066124e4565b506001600160401b0360443581811161086c57610827903690600401612599565b5060643581811161086c57610840903690600401612599565b5060843590811161059c57610859903690600401612614565b506040516343f6e4ab60e01b8152600490fd5b8280fd5b5034610382578060031936011261038257610889612b9b565b60ff60455460181c16600581101561044b5760030361099e573381526046602052604081206002810160038154920190815491831561098c57908490558390556034546035546001600160a01b039185908316803b1561059c578482916109099483604051809781958294637921219560e11b84523033600486016127f4565b03925af191821561097f578592610964575b505061092c91339060335416612bf1565b60405191825260208201527f17c1d890f3ffba4991a771a0b55802a1eff3159d0cce950fb68d1360530393d960403392a26001805580f35b61096f919250612531565b61097b5782843861091b565b8380fd5b50604051903d90823e3d90fd5b60405163aa2ab34760e01b8152600490fd5b60405163bee5a68b60e01b8152600490fd5b50346103825760203660031901126103825760206109d46109cf6124ce565b612835565b604051908152f35b50346103825780600319360112610382576048546040516001600160a01b039091168152602090f35b5034610382578060031936011261038257602060ff604554166040519015158152f35b5034610382576040366003190112610382576001600160401b0360043581811161086c573660238201121561086c5780600401359180831161097b576024808301928460051b010191368311610c67576024359260405191610a8983612544565b601083526020926f30b9b9b4b3b72732bba0bab234ba37b960811b84820152604051848101908860608201604084525260808101848b5b888c8210610c405750505090610aea81610af39594938b604083015203601f19810183528261255f565b51902090612ee0565b610afb578680f35b8515610c2e5784151580610c24575b15610c1257610b1886612582565b95610b26604051978861255f565b8652828087015b838310610bfa575050505060405193610b4585612544565b84528084019283526002600052604d8152604060002093518051928311610be457600160401b8311610be45781908554848755808510610bc7575b50019084600052806000209060005b848110610bac575050505050600190519101553880808080808680f35b83516001600160a01b03168382015592810192600101610b8f565b610bde908760005285846000209182019101612db4565b38610b80565b634e487b7160e01b600052604160045260246000fd5b8190610c05846124fa565b8152019101908390610b2d565b604051633edf0c1d60e11b8152600490fd5b5085851115610b0a565b6040516334a2326d60e11b8152600490fd5b9192909160019181906001600160a01b03610c5a876124fa565b1681520193019101610ac0565b8480fd5b5034610382576040366003190112610382576040610c876124e4565b916004358152604c602052209060018060a01b0316600052602052602060ff604060002054166040519015158152f35b5034610382578060031936011261038257602060ff60485460a01c166040519015158152f35b50346103825780600319360112610382576020604454604051908152f35b503461038257806003193601126103825760ff60455460181c169060058210156106cd57602082600360405191148152f35b50346103825780600319360112610382576033546040516001600160a01b039091168152602090f35b5034610382576020366003190112610382576040906001600160a01b036103266124ce565b50346103825780600319360112610382576020603754604051908152f35b50346103825780600319360112610382576034546040516001600160a01b039091168152602090f35b50346103825780600319360112610382576020604051308152f35b5034610382578060031936011261038257602060ff60405460081c16604051908152f35b5034610382578060031936011261038257338152604960205260ff6040822054161561045f5760455460ff8160181c166005811015610520576001036104395763ff00000019166302000000176045557f6fef0b2343605957335656132e056005ad1e84d5385a242bee16993173ab894c8180a180f35b5034610382578060031936011261038257602060ff60455460101c166040519015158152f35b50346103825780600319360112610382576002604060209233815260468452200154604051908152f35b503461038257604036600319011261038257610ee26124ce565b60243590338352604960205260ff6040842054161561045f576001600160a01b03168083526046602052604083208054919290919060ff821615610f5f578060017fa1f2212603e58faec7cd680910e1c654ef01edb7416cefc2ab2c017a9def5eec9461010060209561ff0019161781550155604051908152a280f35b6040516360f4985360e01b8152600490fd5b503461038257602036600319011261038257610f8b6124ce565b338252604a60205260ff60408320541615610fc9576001600160a01b0381168252604a60205260408220805460ff1916600117905561043690612e4e565b604051630f18e14b60e31b8152600490fd5b503461038257602036600319011261038257610ff56124ce565b338252604a60205260ff60408320541615610fc9576001600160a01b0381168252604960205260408220805460ff1916600117905561043690612dcb565b503461038257806003193601126103825761104c612b9b565b6039546001600160a01b0390811633819003611124576045549060ff8260181c166005811015611110576004036110fe5760ff8260101c166110ec576043549081156110da57620100006110ae9362ff00001916176045558360335416612bf1565b6039541660008051602061352a8339815191526040604354815190815260016020820152a26001805580f35b604051630419563160e51b8152600490fd5b604051633eb203ff60e11b8152600490fd5b604051633df43a3360e11b8152600490fd5b634e487b7160e01b85526021600452602485fd5b604051630f18670360e11b8152600490fd5b503461038257602090816003193601126103825760043560ff81168091036106f357600481101561044b5761116a90612698565b6001926001820154906040519384828554918281520190819583528383209088845b8281106111eb5750505050856111a391038661255f565b60405194604086019060408752518091526060860194915b8181106111cf575050508380955001520390f35b82516001600160a01b03168652948301949183019187016111bb565b83546001600160a01b031685529386019392810192810161118c565b5034610382576101c0366003190112610382576112226124ce565b61122a6124e4565b60643591906001600160a01b03831683036106f3576084356001600160a01b03811681036106f35760a435916001600160a01b03831683036106f35760c435916001600160a01b03831683036106f35760e435906001600160a01b03821682036106f357610164359660ff881688036106f35760ff610184351661018435036106f35760ff6101a435166101a435036106f35788549660ff8860081c1615978880996118cd575b80156118b6575b1561185a5760ff1981166001178b5588611849575b5061130760ff8b5460081c1661130281612d54565b612d54565b600180556001600160a01b03169384151580611837575b15611826576001600160a01b03821615611826576001600160a01b038316156118145761010435151580611808575b156117f65760ff6101a4351660ff61018435160160ff81116117e25760ff6064911610156117d057603380546001600160a01b031990811690961790556034805486166001600160a01b039283161790556044356035556036805486169282169290921790915560388054851692821692909217909155603980548416868316179055603a80548416858316179055603b8054909316911617905561010435603c5561012435620151808181029591801590870490911417156117bc5760018060401b0380951660018060401b0319603d541617603d5561014435603f5561014435603e5560405460ff62ff00006101a43560101b1692169062ffffff19161761ff006101843560081b16171760405563ff00000019604554166045553385526020936049855260408620600160ff19825416179055604a855260408620600160ff1982541617905560018060a01b038216151580611798575b15611770576040516060810181811083821117610be45760405260028152604036878301378092336114d883612828565b5281516001101561175a576001600160a01b0316604091909101525b6040519161150183612544565b8252848201916001835260008052604d865260406000209051928351838111610be457600160401b94858211610be4578890845483865580841061173d575b5001836000528860002060005b83811061172257505050506001905191015560405161156b81612544565b600181528536818301373361157f82612828565b526040519061158d82612544565b8152858101600181526001600052604d875260406000209151805190848211610be457858211610be45788908454838655808410611705575b5001836000528860002060005b8381106116ea575050505060019051910155604051926115f284612544565b600184528536818601376001600160a01b031661160e84612828565b526040519261161c84612544565b835284830191600183526003600052604d865260406000209351908151928311610be4578211610be457859084548386558084106116cd575b5001836000528560002060005b8381106116b257505050506001905191015561167c575080f35b7f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989061ff0019835416835560405160018152a180f35b82516001600160a01b03168282015591870191600101611662565b6116e4908660005284846000209182019101612db4565b38611655565b82516001600160a01b031682820155918a01916001016115d3565b61171c908660005284846000209182019101612db4565b386115c6565b82516001600160a01b031682820155918a019160010161154d565b611754908660005284846000209182019101612db4565b38611540565b634e487b7160e01b600052603260045260246000fd5b604051915061177e82612544565b600182528436818401373361179283612828565b526114f4565b6001600160a01b03831687526049865260408720805460ff191660011790556114a7565b634e487b7160e01b86526011600452602486fd5b604051631825412d60e31b8152600490fd5b634e487b7160e01b8b52601160045260248bfd5b6040516301db9e7b60e61b8152600490fd5b5061014435151561134d565b604051631695a5ef60e11b8152600490fd5b60405162c6e62160e71b8152600490fd5b506001600160a01b038116151561131e565b61ffff1916610101178a55386112ed565b60405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b6064820152608490fd5b50303b1580156112d85750600160ff8216146112d8565b50600160ff8216106112d1565b503461038257806003193601126103825760ff60455460181c169060058210156106cd57602082600260405191148152f35b5034610382578060031936011261038257602060ff60455460081c166040519015158152f35b50346103825780600319360112610382576039546040516001600160a01b039091168152602090f35b50346103825780600319360112610382576020604354604051908152f35b50346103825780600319360112610382576020603e54604051908152f35b50346103825780600319360112610382576020604254604051908152f35b50346103825760208060031936011261059c57600435906119d4612b9b565b60ff60455460181c166005811015611c9d5760011480611cbe575b611cb1575b6119fd33612cbd565b60ff60455460181c166005811015611c9d57600103610439578115611c8b5733835260468152604083209060ff825460081c1615611c7957600182015480611c4e575b5082603e5410611c3c57611a56603c54846127d4565b6033546040516370a0823160e01b815233600482015291936001600160a01b0392909184908290602490829087165afa8015611c315785918891611bfc575b5010611bea5780600260039201611aad8682546127b1565b905501611abb8582546127b1565b9055611ac984603e546127e7565b603e55611ad8836041546127b1565b6041556033546040516323b872dd60e01b848201523360248201523060448201526064808201869052815290821660a082016001600160401b03811183821017611bd657604052611b2991906132e6565b6034541684603554823b1561059c57611b5d92869183604051809681958294637921219560e11b84523330600486016127f4565b03925af18015611bcb57611bb8575b506040519283528201527f8fafebcaf9d154343dad25669bfa277f4fbacd7ac6b0c4fed522580e040a0f3360403392a2603e5415611bab576001805580f35b611bb3612c2b565b6105c1565b611bc490949194612531565b9238611b6c565b6040513d87823e3d90fd5b634e487b7160e01b88526041600452602488fd5b604051632858f9ab60e11b8152600490fd5b809250858092503d8311611c2a575b611c15818361255f565b81010312611c265784905138611a95565b8680fd5b503d611c0b565b6040513d89823e3d90fd5b6040516301369ab160e71b8152600490fd5b611c5c8460038501546127b1565b11611c675738611a40565b60405163dadf976b60e01b8152600490fd5b60405163347ac99560e01b8152600490fd5b604051630f6fa54560e41b8152600490fd5b634e487b7160e01b84526021600452602484fd5b611cb9612c2b565b6119f4565b50603d5460401c6001600160401b03164211806119ef5750603e54156119ef565b50346103825760203660031901126103825760209060ff906040906001600160a01b03611d0a6124ce565b168152604984522054166040519015158152f35b5034610382578060031936011261038257338152604960205260ff6040822054161561045f5760455460ff8160181c16600581101561052057600203611dc557603d5460401c6001600160401b031642118015611dbb575b15611d845750610436612c2b565b63ff00000019166301000000176045557fafee7b9ef6b21bcc119e527ef886f50c6273a9aeac63716137536c653d2f82e68180a180f35b50603e5415611d76565b60405163395fbd0560e01b8152600490fd5b5034610382578060031936011261038257338152604960205260ff6040822054161561045f57611e05612b9b565b60455460ff8160181c166005811015610520576004036110fe5760ff8160081c166110ec576042549081156110da5761ff00191661010017604555603354603a546001600160a01b0392611e5f9290918416908416612bf1565b603a541660008051602061352a83398151915260406042548151908152846020820152a26001805580f35b503461038257806003193601126103825760206109d4612777565b5034610382578060031936011261038257608060ff60455460181c16603e5460415460018060401b03603d5460401c1691611ee3604051809561250e565b602084015260408301526060820152f35b503461038257604036600319011261038257611f0e6124ce565b602435916004831015610382576020611f278484612728565b6040519015158152f35b5034610382578060031936011261038257603d546040516001600160401b039091168152602090f35b5034610382578060031936011261038257603d546040805191901c6001600160401b03168152602090f35b5034610382578060031936011261038257602060ff60405460101c16604051908152f35b50346103825780600319360112610382576038546040516001600160a01b039091168152602090f35b5034610382578060031936011261038257338152604a60205260ff60408220541615610fc957612000612b9b565b60455460ff8160181c166005811015610520576004036110fe5760ff81166110ec5760445490811561098c5760ff19166001176045556033546038546001600160a01b03926120559290918416908416612bf1565b603854167feaff4b37086828766ad3268786972c0cd24259d4c87a80f9d3963a3c3d999b0d6020604454604051908152a26001805580f35b5034610382578060031936011261038257602060ff60455460181c166120b6604051809261250e565bf35b503461038257806003193601126103825760ff60455460181c16600581101561044b576107d157338152604660205260408120805460ff81166121925760ff19166001179055604754600160401b81101561217e57600181018060475581101561216a57604782526000805160206134ea8339815191520180546001600160a01b031916339081179091557f381919937473504a02352aede091840b8e02ca2ce85b2c8513022353225faf778280a280f35b634e487b7160e01b82526032600452602482fd5b634e487b7160e01b82526041600452602482fd5b6040516303d5de1560e61b8152600490fd5b50346103825780600319360112610382576020603f54604051908152f35b50346103825780600319360112610382576020603554604051908152f35b5034610382576020366003190112610382576121fa6124ce565b338252604a60205260ff60408320541615610fc9576001600160a01b03908116808352604960209081526040808520805460ff19169055848052604d90915283209091835b82548082101561232457829085612256848761265b565b939054600394851b1c161461226f57505060010161223f565b93945092600019919082810190811161231057906122a2846122946122c0948961265b565b905490881b1c16918761265b565b90919060018060a01b038084549260031b9316831b921b1916179055565b835480156122fc5701916122d4838561265b565b81939154921b1b1916905581555b60018101805491548092116122f5578280f35b5538808280f35b634e487b7160e01b86526031600452602486fd5b634e487b7160e01b87526011600452602487fd5b50505090506122e2565b5034610382578060031936011261038257602060ff60405416604051908152f35b5034610382578060031936011261038257603a546040516001600160a01b039091168152602090f35b5034610382576040366003190112610382576123926124ce565b6024358015159081810361097b57338452604960205260ff6040852054161561045f5780612400575b6123ee57604880546001600160a81b0319166001600160a01b039093169290921760a09190911b60ff60a01b1617905580f35b6040516303689d2160e21b8152600490fd5b506001600160a01b038216156123bb565b50346103825780600319360112610382576036546040516001600160a01b039091168152602090f35b50346103825760203660031901126103825760209060ff906040906001600160a01b036124656124ce565b168152604a84522054166040519015158152f35b90503461059c57602036600319011261059c5760043563ffffffff60e01b811680910361086c5760209250630271189760e51b81149081156124bd575b5015158152f35b6301ffc9a760e01b149050386124b6565b600435906001600160a01b03821682036106f357565b602435906001600160a01b03821682036106f357565b35906001600160a01b03821682036106f357565b90600582101561251b5752565b634e487b7160e01b600052602160045260246000fd5b6001600160401b038111610be457604052565b604081019081106001600160401b03821117610be457604052565b601f909101601f19168101906001600160401b03821190821017610be457604052565b6001600160401b038111610be45760051b60200190565b9080601f830112156106f35760209082356125b381612582565b936125c1604051958661255f565b81855260208086019260051b8201019283116106f357602001905b8282106125ea575050505090565b813581529083019083016125dc565b6001600160401b038111610be457601f01601f191660200190565b81601f820112156106f35780359061262b826125f9565b92612639604051948561255f565b828452602083830101116106f357816000926020809301838601378301015290565b805482101561175a5760005260206000200190600090565b80549190600160401b831015610be457826122a29160016126969501815561265b565b565b600481101561251b57600052604d602052604060002090565b6000808052604d6020527fbe559d6c67447aa690db1dc4ed6b2b3a2aa069fafafd3242dc649d9043c2e47f805492915b8381106126f15750505050600090565b6126fb818361265b565b905460039190911b1c6001600160a01b039081169084161461271f576001016126e1565b50505050600190565b9061273290612698565b8054919060005b8381106127495750505050600090565b612753818361265b565b905460039190911b1c6001600160a01b039081169084161461271f57600101612739565b60455460ff8116908115612796575b506127915760445490565b600090565b60ff915060181c16600581101561251b576004141538612786565b919082018092116127be57565b634e487b7160e01b600052601160045260246000fd5b818102929181159184041417156127be57565b919082039182116127be57565b929060c0949260018060a01b0380921685521660208401526040830152606082015260a06080820152600060a08201520190565b80511561175a5760200190565b6001600160a01b03166000908152604660205260409020805460081c60ff161561288c57600181015490811561288457600301548181101561287d5761287a916127e7565b90565b5050600090565b5050603e5490565b50600090565b6001600160a01b039091168152602081019190915260400190565b6036546001600160a01b039081169060003383148015612a14575b1561045f5760ff60455460181c16600581101561044b5760048114908115612a09575b50156110fe57816034541660355460405194627eeac760e11b865260208680612918853060048401612892565b0381865afa9586156129fe5784966129ca575b5085156129c257823b1561097b5761296092849283889360405196879586948593637921219560e11b855230600486016127f4565b03925af180156129b757917f328a7cca57e89d3b52f56190ef4e06d91c987e3ef2640db3be95d65f818e2d1293916020936129a8575b50603e556036541692604051908152a2565b6129b190612531565b38612996565b6040513d84823e3d90fd5b505050505050565b9095506020813d6020116129f6575b816129e66020938361255f565b8101031261097b5751943861292b565b3d91506129d9565b6040513d86823e3d90fd5b6003915014386128eb565b50338152604960205260ff6040822054166128c8565b6034549092916001600160a01b039182163303612b675760355403612b315760ff60455460181c1690600582101561251b5760038214612b215780603654169316928303612aef57612abb57602081612aa67fc323a2bcfc04a477ab538e93fedfe40215010d55757a7dd89a96f8e96ffba883936037546127b1565b603755604051908152a263f23a6e6160e01b90565b60405162461bcd60e51b815260206004820152600c60248201526b4e4f545f494e41435449564560a01b6044820152606490fd5b60405162461bcd60e51b815260206004820152600a6024820152692727aa2fa9a2a62622a960b11b6044820152606490fd5b5063f23a6e6160e01b9392505050565b60405162461bcd60e51b815260206004820152600e60248201526d15d493d391d7d513d2d15397d25160921b6044820152606490fd5b60405162461bcd60e51b815260206004820152600c60248201526b2ba927a723afa9a2a72222a960a11b6044820152606490fd5b600260015414612bac576002600155565b60405162461bcd60e51b815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c006044820152606490fd5b612c266126969392612c1860405194859263a9059cbb60e01b602085015260248401612892565b03601f19810184528361255f565b6132e6565b630400000063ff00000019604554161760455560008051602061350a8339815191526040604154612c928254612c8d6064612c8160ff82612c71828760081c16896127d4565b04948560425560101c16866127d4565b049182604355846127e7565b6127e7565b604455603e5482519182526020820152a1565b908160209103126106f3575180151581036106f35790565b6048549060ff8260a01c1615612d50576001600160a01b039182169182156123ee576024602092604051948593849263acf0279f60e01b84521660048301525afa908115612d4457600091612d15575b50156123ee57565b612d37915060203d602011612d3d575b612d2f818361255f565b810190612ca5565b38612d0d565b503d612d25565b6040513d6000823e3d90fd5b5050565b15612d5b57565b60405162461bcd60e51b815260206004820152602b60248201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960448201526a6e697469616c697a696e6760a81b6064820152608490fd5b818110612dbf575050565b60008155600101612db4565b6001600160a01b03818116908115612e3c5760008052604d6020526040600020916000918354925b838110612e1b5750505050612e0a60019282612673565b01805415612e155750565b60019055565b8282612e27838861265b565b90549060031b1c16146129c257600101612df3565b60405163538ba4f960e01b8152600490fd5b6001600160a01b0381811691908215612e3c576001906001600052604d6020526040600020936000918554925b838110612e9457505050505090612e0a60019282612673565b8282612ea0838a61265b565b90549060031b1c1614612eb4578401612e7b565b50505050505050565b60005b838110612ed05750506000910152565b8181015183820152602001612ec0565b6000918280526020604d815260409081852093303314938415613223575b612f3860548551809386612f1b8184019788815193849201612ebd565b820190878201523060601b8882015203603481018452018261255f565b519020926001808601918254908282149182156131fb575b50506131f157848752604b835283872081810180549193916001600160a01b0390818116156130cd575b50878a52604c8652868a20338b52865260ff878b20541615612fa3575b50505050505050505090565b878a52604c8652868a20338b528652868a209260ff1993858582541617905560048601908154918683018093116130b95790828d9897969594939255541115612fed575b50612f97565b600291600386018585825416179055541693019486519285968054613011816133cc565b948184169182156130a157505060011461306a575b505050508281819503925af161303a613406565b501561305a57509061304b91613241565b38808080848180808080612fe7565b5163b8fcdfb760e01b8152600490fd5b8652818620965085905b83821061308b575050508101935082818138613026565b875482860152968701968b965090820190613074565b16865250505050801515028101935082818138613026565b634e487b7160e01b8d52601160045260248dfd5b85546001600160a01b0319908116331787551630178255600285016001600160401b0336116131dd5761310081546133cc565b601f81116131a4575b508a601f361160011461314c578b9036613143575b5036861b906000193660031b1c19161790555b60038501805460ff1916905538612f7a565b9050353861311e565b818c52878c209036601f19168d5b8a8983831061319257505050361161317b575b50508436811b019055613131565b356000193660031b60f8161c19169055388061316d565b8495829395358155019401920161315a565b6131cd90828d52888d20601f360160051c8101918a36106131d3575b601f0160051c0190612db4565b38613109565b90915081906131c0565b634e487b7160e01b8b52604160045260248bfd5b9550505050505090565b878a52604b8652868a2060040154101591508161321b575b503880612f50565b905038613213565b61322c336126b1565b612efe578351630790a08960e11b8152600490fd5b9190916000818152602091604b6020526040926040832094835b87548110156132c257806132716001928a61265b565b838060a01b0391549060031b1c16858752604c808652888820828952865260ff89892054166132a3575b50500161325b565b86885285528787209087528452868620805460ff19169055388061329b565b506001860180546001600160a01b0319169055600490950192909255509192505050565b604051613344916001600160a01b03166132ff82612544565b6000806020958685527f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c656487860152868151910182855af161333e613406565b91613436565b8051908282159283156133b4575b5050501561335d5750565b6084906040519062461bcd60e51b82526004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e6044820152691bdd081cdd58d8d9595960b21b6064820152fd5b6133c49350820181019101612ca5565b388281613352565b90600182811c921680156133fc575b60208310146133e657565b634e487b7160e01b600052602260045260246000fd5b91607f16916133db565b3d15613431573d90613417826125f9565b91613425604051938461255f565b82523d6000602084013e565b606090565b91929015613498575081511561344a575090565b3b156134535790565b60405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e74726163740000006044820152606490fd5b8251909150156134ab5750805190602001fd5b6044604051809262461bcd60e51b8252602060048301526134db8151809281602486015260208686019101612ebd565b601f01601f19168101030190fdfec43c1e24e1884c4e28a16bbd9506f60b5ca9f18fc90635e729d3cfe13abcf0011e58a3aa29fc35743849a583908bdeca435e9b283cfc1f125d31961113b863c686c04e64d4321047649533f7637585849fc61b507eeb26d501d60ab6f0e59a8ca164736f6c6343000818000a",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
};

export default CarbonCreditPrivateOffering;
